/**
 * N.3 — Tüm Notlar (Arşiv)
 * gm_yonetici ve super_admin tüm notları görür, filtreleyebilir
 */
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import RichEditor from '../components/RichEditor';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const tkn = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const DURUM_RENK: Record<string, string> = {
  taslak: '#888', onay_bekliyor: '#e67e22', onaylandi: '#27ae60', reddedildi: '#e74c3c',
};
const DURUM_AD: Record<string, string> = {
  taslak: 'Taslak', onay_bekliyor: 'Onay Bekliyor', onaylandi: 'Onaylandı', reddedildi: 'Reddedildi',
};

const SABIT_ALANLAR = [
  { key: 'birim', label: 'Birim' }, { key: 'konu', label: 'Konu' },
  { key: 'sunulan_makam', label: 'Sunulan Makam' }, { key: 'hazirlayan', label: 'Hazırlayan' },
  { key: 'tarih', label: 'Tarih' }, { key: 'yonetici_ozeti', label: 'Yönetici Özeti' },
  { key: 'ana_metin', label: 'Ana Metin' }, { key: 'istatistiki_bilgi', label: 'İstatistiki Bilgiler' },
  { key: 'sonuc', label: 'Sonuç ve Değerlendirme' },
];
const RICHTEXT_KEYS = new Set(['yonetici_ozeti', 'ana_metin', 'istatistiki_bilgi', 'sonuc']);

export default function BilgiNotArsiv() {
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const isAdmin = user?.rol === 'super_admin';

  const [notlar, setNotlar] = useState<any[]>([]);
  const [secili, setSecili] = useState<any>(null);
  const [akis, setAkis] = useState<any[]>([]);
  const [filtre, setFiltre] = useState({ arama: '', durum: '' });
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [mesaj, setMesaj] = useState('');

  const yukle = useCallback(async () => {
    setYukleniyor(true);
    try {
      const params: any = { goruntule: 'arsiv' };
      if (filtre.arama) params.arama = filtre.arama;
      if (filtre.durum) params.durum = filtre.durum;
      const r = await axios.get(`${API}/api/bilgi-notu/`, { headers: tkn(), params });
      setNotlar(r.data);
    } catch (e: any) {
      setHata(e.response?.data?.detail || 'Yükleme hatası');
    } finally { setYukleniyor(false); }
  }, [filtre]);

  useEffect(() => { yukle(); }, [yukle]);

  const detayAc = async (n: any) => {
    setSecili(n);
    try {
      const r = await axios.get(`${API}/api/bilgi-notu/${n.id}/akis`, { headers: tkn() });
      setAkis(r.data);
    } catch { setAkis([]); }
  };

  const onayiKaldir = async (n: any) => {
    if (!window.confirm('Bu notun onayını kaldırmak ve taslağa almak istediğinizden emin misiniz?')) return;
    try {
      await axios.post(`${API}/api/bilgi-notu/${n.id}/geri-al`, {}, { headers: tkn() });
      setMesaj('Onay kaldırıldı, not taslağa alındı');
      yukle(); setSecili(null);
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata'); }
  };

  if (secili) return (
    <div style={{ padding: 24, maxWidth: 860, margin: '0 auto' }}>
      <button onClick={() => setSecili(null)}
        style={{ background: 'none', border: 'none', color: '#1a4a7a', cursor: 'pointer', fontSize: 14, marginBottom: 12 }}>
        ← Listeye Dön
      </button>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
        <div>
          <h2 style={{ margin: 0, color: '#1a4a7a' }}>{secili.alanlar?.konu || 'Bilgi Notu'}</h2>
          <div style={{ color: '#666', fontSize: 13, marginTop: 4 }}>
            {secili.hazirlayan_ad} • {secili.hazirlayan_birim} •{' '}
            <span style={{ background: DURUM_RENK[secili.durum] + '22', color: DURUM_RENK[secili.durum], padding: '1px 8px', borderRadius: 10, fontSize: 12, fontWeight: 600 }}>
              {DURUM_AD[secili.durum]}
            </span>
          </div>
        </div>
        {isAdmin && secili.durum === 'onaylandi' && (
          <button onClick={() => onayiKaldir(secili)}
            style={{ background: '#fff8e1', color: '#b7950b', border: '1px solid #f9e47b', borderRadius: 6, padding: '6px 14px', cursor: 'pointer', fontSize: 13 }}>
            Onayı Kaldır
          </button>
        )}
      </div>

      {hata && <div style={{ background: '#fdecea', color: '#c0392b', padding: '10px', borderRadius: 6, marginBottom: 12 }}>{hata}</div>}
      {mesaj && <div style={{ background: '#eafaf1', color: '#1e8449', padding: '10px', borderRadius: 6, marginBottom: 12 }}>{mesaj}</div>}

      <div style={{ border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden', marginBottom: 20 }}>
        <div style={{ background: '#1a4a7a', color: '#fff', padding: '12px 20px', fontWeight: 600 }}>📄 Bilgi Notu</div>
        <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 20 }}>
          {SABIT_ALANLAR.filter(a => secili.alanlar?.[a.key]).map(alan => (
            <div key={alan.key}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#777', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6 }}>
                {alan.label}
              </div>
              {RICHTEXT_KEYS.has(alan.key)
                ? <RichEditor value={secili.alanlar[alan.key]} onChange={() => {}} disabled />
                : <div style={{ fontSize: 15, color: '#222' }}>{secili.alanlar[alan.key]}</div>
              }
            </div>
          ))}
        </div>
      </div>

      {secili.red_nedeni && (
        <div style={{ background: '#fdecea', color: '#c0392b', padding: '12px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>
          ❌ <strong>Red Nedeni:</strong> {secili.red_nedeni}
        </div>
      )}

      {akis.length > 0 && (
        <div style={{ background: '#f8f9fa', borderRadius: 8, padding: 16, border: '1px solid #e0e0e0' }}>
          <div style={{ fontWeight: 600, marginBottom: 10, color: '#555' }}>İşlem Geçmişi</div>
          {akis.map((a: any, i: number) => (
            <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 6, fontSize: 13 }}>
              <span style={{ color: '#999', minWidth: 130 }}>{a.tarih?.slice(0, 16).replace('T', ' ')}</span>
              <span style={{ fontWeight: 500 }}>{a.yapan_ad}</span>
              <span style={{ color: '#666' }}>— {a.islem.replace(/_/g, ' ')}</span>
              {a.aciklama && <span style={{ color: '#e74c3c' }}>({a.aciklama})</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: '0 auto' }}>
      <h2 style={{ color: '#1a4a7a', marginBottom: 16 }}>📚 Tüm Bilgi Notları (Arşiv)</h2>

      {/* Filtreler */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <input
          type="text" placeholder="Konu veya hazırlayan ara..."
          value={filtre.arama}
          onChange={e => setFiltre(f => ({ ...f, arama: e.target.value }))}
          style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #ccc', fontSize: 14, minWidth: 240 }}
        />
        <select value={filtre.durum} onChange={e => setFiltre(f => ({ ...f, durum: e.target.value }))}
          style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #ccc', fontSize: 14 }}>
          <option value="">— Tüm Durumlar —</option>
          <option value="taslak">Taslak</option>
          <option value="onay_bekliyor">Onay Bekliyor</option>
          <option value="onaylandi">Onaylandı</option>
          <option value="reddedildi">Reddedildi</option>
        </select>
        <button onClick={yukle}
          style={{ padding: '8px 18px', background: '#1a4a7a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
          Filtrele
        </button>
      </div>

      {hata && <div style={{ background: '#fdecea', color: '#c0392b', padding: '10px', borderRadius: 6, marginBottom: 12 }}>{hata}</div>}
      {mesaj && <div style={{ background: '#eafaf1', color: '#1e8449', padding: '10px', borderRadius: 6, marginBottom: 12 }}>{mesaj}</div>}

      {yukleniyor ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Yükleniyor...</div>
      ) : notlar.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#aaa', fontSize: 15 }}>Kayıt bulunamadı.</div>
      ) : (
        <>
          <div style={{ color: '#888', fontSize: 13, marginBottom: 8 }}>{notlar.length} not bulundu</div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: '#f0f4f8', borderBottom: '2px solid #ddd' }}>
                {['Konu', 'Hazırlayan', 'Birim', 'Tarih', 'Onaylayan', 'Durum', 'İşlem'].map(h => (
                  <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#444' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {notlar.map(n => (
                <tr key={n.id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 12px', maxWidth: 200, fontWeight: 500 }}>{n.alanlar?.konu || '—'}</td>
                  <td style={{ padding: '10px 12px', color: '#555' }}>{n.hazirlayan_ad}</td>
                  <td style={{ padding: '10px 12px', color: '#666', fontSize: 12 }}>{n.hazirlayan_birim || '—'}</td>
                  <td style={{ padding: '10px 12px', color: '#666', whiteSpace: 'nowrap' }}>
                    {n.alanlar?.tarih || n.olusturma_tarihi?.slice(0, 10)}
                  </td>
                  <td style={{ padding: '10px 12px', color: '#555' }}>{n.onaylayan_ad || '—'}</td>
                  <td style={{ padding: '10px 12px' }}>
                    <span style={{
                      background: DURUM_RENK[n.durum] + '22', color: DURUM_RENK[n.durum],
                      padding: '2px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600,
                    }}>{DURUM_AD[n.durum] || n.durum}</span>
                  </td>
                  <td style={{ padding: '10px 12px' }}>
                    <button onClick={() => detayAc(n)}
                      style={{ background: '#eaf3fb', color: '#1a4a7a', border: '1px solid #bdd', borderRadius: 5, padding: '3px 10px', cursor: 'pointer', fontSize: 13 }}>
                      İncele
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
